import { wishListCardStyles } from "@insite/content-library/Components/WishListCard";
import { StyledButton } from "@insite/mobius/Clickable";
import { GridOffset } from "@insite/mobius/GridContainer";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

wishListCardStyles.gridContainer = {
    gap: 5,
    css: css`
        border: 1px solid ${getColor("common.border")};
        /* border-radius: 4px; */
        padding: 1rem;
        > ${GridOffset} {
            align-items: center;
            width: 100%;
        }
    `,
};
wishListCardStyles.detailLinkGridItem = {
    width: 12,
    css: css`
       padding-top: 0;
        > ${StyledButton} {
            > ${TypographyStyle} {
                font-weight: bold;
            }
        }
    `,
};
wishListCardStyles.actionAddToCartButton = {
    variant: "primary",
    css: css`
        white-space: nowrap;
        width: 100%;
        padding: 0 10px;
        font-size: inherit;
        > ${TypographyStyle} {
            font-size: inherit;
        }
    `,
};
wishListCardStyles.actionDeleteButton = {
    variant: "secondary",
    css: css`
        width: 100%;
        margin-top: 10px;

        > ${TypographyStyle} {
            /* font-size: 1rem; */
        }
    `,
};
wishListCardStyles.lastUpdatedText = {
    size: 14,
};
wishListCardStyles.sharingStatus = {
    statusText: {
        size: 14,
    },
};
wishListCardStyles.wishListInfoGridContainer = {
    css: css`
        ${GridOffset} {
            align-items: center;
        }
    `,
};
wishListCardStyles.descriptionText = {
    size: 14,
};
wishListCardStyles.wishListInfoGridItem = {
    width: [10, 10, 8, 9, 10],
    align: "middle",
};
wishListCardStyles.actionGridItem = {
    width: [2, 2, 4, 3, 2],
    align: "top",
    css: css`
        justify-content: flex-end;
    `,
};
